import { render } from "./ExtraInfo.vue?vue&type=template&id=a58f2cd4&ts=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=ts"
export * from "./ExtraInfo.vue?vue&type=script&lang=ts"

import "./ExtraInfo.vue?vue&type=style&index=0&id=a58f2cd4&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__